export default "__VITE_ASSET__DsVaBwtp__"